import { Category } from "@/@types/changeservice";
import { GetRequestPublic } from "./RequestTemplates";

export type CategoryResponse = {
  categoryName: string;
  categoryType: string;
  description: string;
  icon: string;
  id: string;
  slug: string;
  sortPriority: number;
};

export const fetchCategoryBySlug = async (categorySlug: string): Promise<Category> => {
  return GetRequestPublic(`${process.env.API_SERVER_URL}/provider/category/slug/${categorySlug}`).then(
    (res) => res.data
  );
};

export const fetchAllCategories = async (): Promise<Category[]> => {
  return GetRequestPublic(`${process.env.API_SERVER_URL}/provider/category/abstract-services`).then((res) => res.data);
};
